import {Module} from "wrapper6";

export default class ContactTracking extends Module {
    ready() {
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            if(event.detail.contactFormId == 5 || event.detail.contactFormId == 2409){
                ga( 'send', 'event', 'Nyhedsbrev', 'submit', 'Nyhedsbrev' );
                dataLayer.push({'event': 'Nyhedsbrev', 'formName': 'Nyhedsbrev'});
            }
        }, false );
    }
}